<template>
  <es-layout
    custom-class
    layout="{{['header','footer']}}"
    navbarTitle="短信核验"
    leftArrow="{{true}}"
    navbarStyle="{{navbarStyle}}"
  >
    <view class="backgroundStyle">
      <view class="es-background-card">
        <block wx:if="{{!isFromDigitCode}}">
          <view class="titleStyle">第一步：获取验证码 </view>
          <view class="contentStyle"
            >请用手机<text class="es-font-sent">{{ phoneTips }}</text
            >发送短信 <text class="es-content-hover">{{msg}}</text>至<text class="es-content-hover"
              >12306</text
            >，获取短信验证码
          </view>
          <block>
            <view class="buttonStyle" bindtap="sendMessage">去发送校验短信</view></block
          >
        </block>
        <view class="titleStyles">{{title}}</view>
        <view class="contentStyle"
          >请在<text class="es-font-sent">10</text>分钟内，输入<text class="es-font-sent"
            >12306</text
          >返回的验证码，点击提交核验</view
        >
        <view class="inputContainerStyle">
          <view class="messageStyle"> 验证码 </view>
          <view class="messageBorder">|</view>
          <input
            type="text"
            class="inputStyle"
            placeholder="请输入6位数验证码"
            wx:model="{{inputdata}}"
            maxlength="{{6}}"
          />
        </view>
        <view class="buttonStyle" wx:class="{{actives}}" bindtap="onClick">{{btnText}}</view>
      </view>
    </view>
    <view class="tips" wx:if="{{isALIMini}}">
        <image class="tips-icon" src="{{tipsIcon}}"/>
        <view class="tips-title">温馨提示</view>
        <block wx:for="{{ tipsText }}">
        <view class="tips-text">{{item}}</view>
        </block>
    </view>
    <successDialog 
      show="{{showDialog}}" 
      title="注册成功"
      account="{{nickname}}" 
      password="{{password}}" 
      bind:confirm="gotologin"/>
    <failDialog 
      show="{{showFailDialog}}" 
      title="核验失败"
      msg="{{failmsg}}"
      bind:confirm="gocurrent"/>
  </es-layout>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { AES_ECB_DECRYPT, AES_ECB_ENCRYPT } from '@/common/crypto' 
  import store from '@/store'
  import { bridge, query } from '@didi/webx-js'
  import { isDdPassengerH5, isALIMini } from '@/common/constant'
  import { innerRouter, pagePath } from "@/common/jump"
  import { LOAD_FAIL_CONTENT } from "@/common/constant"
  import { getMessageVerification } from "@/api/login12306"
  import { trackEvent } from '@/common/track'
  
  createPage({
    data: {
      inputdata: '',
      activeHover: true,
      tipsIcon: 'https://img-hxy021.didistatic.com/static/starimg/img/A32O0uBy9q1687145809880.png',
      isALIMini: isALIMini,
      showDialog: false,
      showFailDialog: false,
      failmsg:""
    },
    computed: {
      ...store.mapState({
        userInfo12306: 'login12306.userInfo12306'
      }),
      isFromDigitCode(){
        const { code } = query();
        return code === "10610"
      },
      title(){
        return this.isFromDigitCode? "请输入 12306 短信验证码":"第二步：输入验证码"
      },

      navbarStyle(){
        return {
          background: '#ffffff'
        }
      },
      isFromRegister(){
        const { from } = query();
        return from === "register"
      },
      tipsText(){
        return [
          '1、请根据以上步骤完成核验操作。',
          `2、如获取验证码失败，您也可以直接使用手机短信功能， 发送 ${this.msg} 至 12306。`,
          '3、收到12306验证码后，请及时提交验证并等待核验结果。'

        ]
      },
      nickname(){
        return query()?.nickname
      },
      password(){
        return query()?.password
      },
      msg(){
        return this.isFromRegister? '999':'666'
      },
      phoneTips(){
        const { phone } = query();
        return this.isFromRegister? phone:this.userInfo12306.tips 
      },
      btnText(){
        return this.isFromRegister? '完成注册':'提交核验'
      },
      actives() {
        const { activeHover } = this

        if (this.inputdata.length) {
          this.activeHover = false
          return {
            'button-not-active': false
          }
        } else {
          this.activeHover = true
          return {
            'button-not-active': true
          }
        }
      }
    },
    methods: {
      ...store.mapActions({
        messageVerification: 'login12306.messageVerification'
      }),
      sendMessage() {
        // 星河小程序
        // dd.shareMessage({
        //   recipients: ['12306'],
        //   content: '666'
        // })
        // if (isDdPassengerH5) {
        //   bridge.shareSMS({
        //     type: 'text',
        //     content: '666'
        //   })
        // } 
        if (__mpx_mode__ === 'web') {
          let url = `sms:12306?body=${this.msg}`
          window.location.href = this.getMsgUrl(url)
        }
      },
      getMsgUrl(url) {
        const platform = mpx.getSystemInfoSync().platform
        if (platform == 'iPhone' || platform == 'ios') {
          return url.replace('?', '&')
        } else {
          return url
        }
      },
      changeNum(event) {
        const { value } = event.detail
        if (value.length > 6) {
          this.inputdata = value.slice(0, 6)
        }
      },

      goPage(type) {
        //跳转到下一个页面
        const options = {
          list: {}
        }
        const urls = {
          list: pagePath().PAGESINDEX
        }
        innerRouter.push(urls[type], options[type])
      },
      gotologin(){
        innerRouter.goback(2)
      },
      gocurrent(){
        this.showFailDialog = false
      },
      registerVerification(options){
        getMessageVerification(options).then((res) => {
          mpx.hideLoading();
          const { data, code, success, message } = res;
          if (success) {
            if (code === "0") {
              // 注册成功
              this.showDialog = true
            } else {
              this.showFailDialog = true
              this.failmsg = message
            }
          } else {
            mpx.showToast({
              title: LOAD_FAIL_CONTENT, //提示的内容,
              icon: "error", //图标,
              duration: 2000, //延迟时间,
            });
          }

        })
        console.error('submit');
      },
      onClick() {
        // if (!this.activeHover) {
        //   console.log(this.userInfo12306, 'userInfo12306')
        // }
        if (this.inputdata.trim().length === 0) {
          mpx.showToast({
            title: '请输入验证码',
            icon: 'error'
          })
          return false
        }
        if (this.isFromRegister){
          trackEvent('userteam_train_regpage_complete_ck', 'UT-火车票-注册页面-完成注册-点击')
          const { phone, account,password } = query
          const params ={
            captcha: this.inputdata,
            phone: AES_ECB_ENCRYPT(phone), //加密
            type:2,
          }
          this.registerVerification(params)
        }else{
          const { from } = this.$mpxRoute.query || {}
          const params ={
            phone: this.userInfo12306.phone,
            captcha: this.inputdata,
            type:  this.userInfo12306['type'],
            account: this.userInfo12306['account'],
            password: this.userInfo12306['password'],
            account_with_star: this.userInfo12306['account_with_star'],
            tickets12306: from === 'tickets12306'
          }
          this.messageVerification(params)
        }
      }
    },
    mounted() {}
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-view-page
    background-color $train-color-background
  .es-navbar
    background #ffffff
  .es-content-hover
    color $train-color-theme-blue
    font-size 16px
    font-family sans-serif
  .es-background-card
    background #ffffff
    border-radius 8px
    padding 16px 12px
    padding-top 0
  .tab-label
    padding 0 5px
    position absolute
    font-size 10px
    height 18px
    line-height 18px
    color #ffffff
    background #FD6C19
    border-radius 9px
    border 1px solid #ffffff
  .backgroundStyle
    padding 12px
    background-color $train-color-background
  .title
    margin-left 10px
    padding 10 20
    color black
    font-size 20px
    text-align center
    background #FD6C19
    border 1px solid #ffffff
    width 250px
    height 25px
  .titleStyle
    padding-top 16px
    padding-bottom 12px
    color #000000
    font-size 18px
    font-weight bold
  .titleStyles
    padding-top 24px
    padding-bottom 12px
    color #000000
    font-size 18px
    font-weight bold
  .contentStyle
    color $train-color-666
    font-size 16px
    font-family PingFangSC
  .messageStyle
    color $train-color-333
    font-size 15px
    display inline-block
    // width 60px
    text-align center
    flex 0 0 50px
  .inputStyle
    font-size 15px
    color $train-color-666
    outline none
    height 22px
    caret-color $train-color-theme-blue
  .messageBorder
    color #C0C0C0
    padding 0 10px
  .buttonStyle
    margin-top 16px
    color white
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 13px 10px
    text-align center
    border-radius 8px
  .search
    color $train-color-divider-cc
    font-size 15px
    height 44px
    padding 13px
    width 100%
    outline none
    box-sizing border-box
  .inputContainerStyle
    margin-top 10px
    padding 10px
    display flex
    align-items center
    border-radius 8px
    border 2px #F3F3F3 solid
    width 100%
    box-sizing border-box
  .inputStyle::placeholder
    color $train-color-divider-ccc
  .button-not-active
    background $train-color-divider-ccc
  .es-navbar-view
    background-color #ffffff
  .es-font-sent
    font-family sans-serif
    color $train-color-theme-blue
  .tips-icon
    width 14px
    height 14px
    position absolute
    left 13px
  .tips-title
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    letter-spacing 0em
    line-height 14px
    letter-spacing 0px
    color #333333
    margin-bottom 7px
    margin-left 29px
    margin-right 14px
  .tips-text
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    letter-spacing 0em
    line-height 14px
    letter-spacing 0px
    color #3D3D3D
    margin-left 29px
    margin-right 14px
</style>

<script name='json'>
  module.exports = {
    component: true,
    // navigationBarTitleText: '短信核验',
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      "successDialog":"./components/register/success-dialog",
      "failDialog":"./components/register/fail-dialog",
    }
  }
</script>
